import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { PlanMappingView } from '../../products/components'
import * as apiActions from 'api-actions'

function mapStateToProps(state) {
  return {
    participantsForSubmission: selectors.participantsForSubmission(state),
    completedServicesAgreements: selectors.completedServicesAgreements(state),
    discardedParticipants: selectors.discardedParticipants(state),
    participantsAgreementHash: selectors.participantsAgreementHash(state),
    planMatchResults: selectors.planMatchResults(state),
  }
}

const mapDispatchToProps = {
  setParticipantsAgreementHash: actions.setParticipantsAgreementHash,
  updateParticipantsWithMappedAgreement:
    actions.updateParticipantsWithMappedAgreement,
  setDiscardedParticipants: actions.setDiscardedParticipants,
  fetchPlanMatches: apiActions.fetchPlanMatches,
}

const ConnectedPlanMappingView = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(PlanMappingView)

export default function TaxableAccountsPlanMappingView(props) {
  return (
    <ConnectedPlanMappingView
      {...props}
      uploadFilePath="/taxable-accounts/upload-file"
      planConfirmationPath="/taxable-accounts/plan-confirmation"
      formType="Taxable"
    />
  )
}
